import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/payments';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async export(params: any) {
    return api.export(params);
  }

  @Action
  async withdraw(params: any) {
    return api.withdraw(params);
  }

  @Action
  async exportwithdraw(params: any) {
    return api.exportwithdraw(params);
  }

  @Action
  async opAIBoxPrice(params: any) {
    return api.opAIBoxPrice(params);
  }

}
